import { API_REQUEST, GET_COMMERCIAL_RECONCILIATION, RESET_COMMERCIAL_RECONCILIATION } from "../../actionTypes/actionsTypes";
import { AppAction, LocalAction } from "../../types";

export const getCommercialReconciliation = (profileID: number | string, currentSnapshotId: string): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: `/income/get-commercial-reconciliation/${profileID}/${currentSnapshotId}`,
    next: GET_COMMERCIAL_RECONCILIATION,
    method: 'GET',
    authorization: true
  }
});

export const resetCommercialReconciliation = (): LocalAction => ({
    type: RESET_COMMERCIAL_RECONCILIATION
});